import { IconCheck } from '@justeattakeaway/pie-icons-react';
import { PIEComponentUtil } from '@src/shared/components/PIEComponentUtil';
import PIETag, { ETagsColorType } from '@src/shared/components/PIETag';
import React, { FC } from 'react';
import { globalStyles } from 'snacks-design-system';
import style from './TagDelivered.module.scss';
import { useTranslation } from 'react-i18next';

const { xdsSpacingB } = globalStyles;
interface ITagDeliveredProps {
  deliveredTime?: string;
}
const TagDelivered: FC<ITagDeliveredProps> = ({ deliveredTime }) => {
  const { t } = useTranslation();
  return (
    <PIETag mode={ETagsColorType.Success}>
      <PIEComponentUtil paddingX={xdsSpacingB}>
        <IconCheck className={style.icon} size="xs" style={{ marginRight: '4px' }} />
        {t('order.status_DELIVERED')} {deliveredTime ? `${deliveredTime}` : ''}
      </PIEComponentUtil>
    </PIETag>
  );
};

export default TagDelivered;
